// React
import React, { useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

// types
import { TableauViz, TableauDialogType } from '../types';

export type BiVisualProps = {
    isDev: boolean;
    url: string;
    onLoaded: () => void;
    //onFilter: ()=>void
};

export type BiVisualMethods = {
    showExcel: () => void;
    showPdf: () => void;
};

// eslint-disable-next-line react/display-name
const BiVisual = forwardRef((props: BiVisualProps, ref) => {
    const _viz = useRef<TableauViz | null>(null);
    //const _chartHeight = useRef<number>(620);

    // parent click calls showExcel or showPdf click handlers
    useImperativeHandle(ref, () => {
        return {
            showExcel(): void {
                console.log('BI VIZ: show excel');
                if (_viz.current) {
                    _viz.current.displayDialogAsync(TableauDialogType.ExportCrossTab);
                }
            },
            showPdf(): void {
                console.log('BI VIZ: show pdf');
                if (_viz.current) {
                    _viz.current.displayDialogAsync(TableauDialogType.ExportPDF);
                }
            },
        };
    }, []);

    // INIT
    useEffect(() => {
        console.log('BI VIZ: init');

        const elem = document.getElementById('biVisual');
        if (!!!elem) {
            return;
        }

        // width and height: from bounding rect
        const elemRect = elem.getBoundingClientRect();
        const chartWidth = elemRect.width;
        let chartHeight = elemRect.height;

        // auto height
        console.log('BI VIZ: initial height: ' + chartHeight);
        let elemTop = document.getElementById('biVisual'),
            offsetY = 0;
        while (!!elemTop) {
            // page wrapper found
            if (elemTop.id == 'wrapper') {
                break;
            }
            offsetY += elemTop.offsetTop;
            elemTop = elemTop.offsetParent as HTMLElement;
        }
        elemTop = null;

        // extra height available
        const extraHeight = window.innerHeight - offsetY - chartHeight;
        console.log('BI VIZ: viz offset from wrapper top: ' + offsetY + ', window portal: ' + window.innerHeight);
        console.log('BI VIZ: extra height = window viewport - offset from top - viz height: ' + extraHeight);
        if (extraHeight - 30 > 10) {
            // 30px small bump off bottom
            chartHeight = chartHeight + (extraHeight - 30);
            elem.style.height = chartHeight + 'px';
            console.log('BI VIZ: using extra height, viz new height is: ' + chartHeight);
        }

        // url is not set
        if (!!!props.url) {
            console.log('BI VIZ: url not loaded, exiting');
            return;
        }
        console.log('BI VIZ url: ' + props.url);

        // add placeholder img during dev
        if (props.isDev) {
            console.log('BI VIZ: DEV MODE LOADED');
            const img = document.createElement('img');
            img.src = '/assets/img/app/bi/CEMatchedDispenses.png';
            img.classList.add('bi-img-dev-mode');
            elem.appendChild(img);
            setTimeout(() => {
                props.onLoaded();
            }, 2000);
            return;
        }

        // launch Tableau embedded on div id="biVisual"
        // v3 embedding API: no more window.tableau.Viz, use the <tableau-viz> custom element instead
        const TableauXGutter = 10;
        const TableauYGutter = 10;
        const viz = document.createElement('tableau-viz') as TableauViz;
        viz.src = props.url;
        viz.toolbar = 'hidden';
        viz.hideTabs = false;
        viz.width = chartWidth - TableauXGutter + 'px';
        viz.height = chartHeight - TableauYGutter + 'px';
        viz.addEventListener('firstinteractive', (): void => {
            props.onLoaded();
            console.log('BI VIZ: on first interactive');
        });
        elem.appendChild(viz);
        _viz.current = viz;

        // destroy
        return (): void => {
            if (_viz.current) {
                // removing from DOM triggers the element's disconnectedCallback which disposes the viz
                _viz.current.remove();
                console.log('BI VIZ: unload');
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // RENDER
    console.log('BI VIZ: render');
    return <div id="biVisual"></div>;
});

export default BiVisual;
